module.exports = __webpack_public_path__ + "img/compromiso.a8164be4.jpg";